<template>
  <div class="vh-100">
    <b-navbar class="p-0" type="dark" variant="dark">
      <b-navbar-nav :small="true">
        <slot name="nav"></slot>
      </b-navbar-nav>
    </b-navbar>
    <div class="editor">
      <vue-resizable :width="sidebarWidth" :active="handlers" :maxWidth="500" :minWidth="200"
        @resize:move="onSidebarResize">
        <div class="sidebarPanel p-3" v-if="nodes">
          <vue-tree-list @click="onClick" @change-name="onChangeName" @delete-node="onDel" @add-node="addNode"
            :model="nodes" default-tree-node-name="new folder" default-leaf-node-name="new file"
            v-bind:default-expanded="false" >
            <template v-slot:leafNameDisplay="slotProps">
              <div @contextmenu="
                                      (e) => {
                                        openMenu(e, slotProps.model);
                                      }
                                    ">
                <span v-if="nodeEditable == slotProps.model.id"><b-input variant="dark" v-model="currentMenuNode.name"
                    @keyup.enter="nodeNameChange" ref="renameInput" /></span>
                <span v-else>{{ slotProps.model.name }}</span>
              </div>
            </template>
  
            <span class="icon" slot="addTreeNodeIcon"></span>
            <span class="icon" slot="addLeafNodeIcon"></span>
            <span class="icon" slot="editNodeIcon"></span>
            <span class="icon" slot="delNodeIcon"></span>
  
            <template v-slot:leafNodeIcon="slotProps">
              <img :src="iconRender(slotProps.model.ext)" class="fileIcon" />
              <span v-if="slotProps.model.root">📱</span>
            </template>
          </vue-tree-list>
  
          <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu" @blur="closeMenu"
            :style="{ top: top, left: left }">
            <li v-for="nodeAction in nodeActions()" @click="triggerNodeAction(nodeAction)" :key="nodeAction">
              {{ nodeAction }}
            </li>
          </ul>
        </div>
      </vue-resizable>
      <vue-resizable :width="leftEditorWidth" v-if="activeEditorsRight.length" :active="handlers"
        @resize:move="onEditorResize">
        <div class="editorPanel" ref="editorPanel">
          <b-tabs class="editorTabs" no-fade v-model="activeTab">
            <b-tab class="editorTab" v-for="activeEditor in activeEditors" :key="activeEditor.id">
              <template #title>
                {{ activeEditor.name }}
                <span class="closeTabIcon" @click="closeActiveEditor(activeEditor)">x</span>
              </template>
              <small class="filePath">
                {{ generateNodePath(activeEditor, activeEditor.name) }}
              </small>
              <codemirror @input="(e) => editorInput(activeEditor, e)" :value="currentEditorValue(activeEditor)"
                @ready="onCmReady" :options="editorOptions(activeEditor.editorOptions)" class="codeEditor">
              </codemirror>
            </b-tab>
          </b-tabs>
        </div>
      </vue-resizable>
      <div v-else class="editorPanel w-100" ref="editorPanel">
        <b-tabs class="editorTabs" no-fade v-model="activeTab">
          <b-tab class="editorTab" v-for="activeEditor in activeEditors" :key="activeEditor.id">
            <template #title>
              {{ activeEditor.name }}
              <span class="closeTabIcon" @click="closeActiveEditor(activeEditor)">x</span>
            </template>
            <small class="filePath">
              {{ generateNodePath(activeEditor, activeEditor.name) }}
            </small>
            <codemirror @input="(e) => editorInput(activeEditor, e)" :value="currentEditorValue(activeEditor)"
              @ready="onCmReady" :options="editorOptions(activeEditor.editorOptions)" class="codeEditor">
            </codemirror>
          </b-tab>
        </b-tabs>
      </div>
      <div v-if="activeEditorsRight.length" class="editorPanelRight" ref="editorPanelRight">
        <b-tabs class="editorTabs" no-fade v-model="activeTabRight">
          <b-tab class="editorTab" v-for="activeEditorRight in activeEditorsRight" :key="activeEditorRight.id">
            <template #title>
              {{ activeEditorRight.name }}
              <span class="closeTabIcon" @click="closeActiveEditorRight(activeEditorRight)">x</span>
            </template>
            <small class="filePath">
              {{ generateNodePath(activeEditorRight, activeEditorRight.name) }}
            </small>
            <codemirror @input="(e) => editorInput(activeEditorRight, e)" :value="currentEditorValue(activeEditorRight)"
              @ready="onCmReady" :options="editorOptions(activeEditorRight.editorOptions)" class="codeEditor">
            </codemirror>
          </b-tab>
        </b-tabs>
      </div>
      <Footer fixed style="margin: 0">
        <b-row style="width: 100%">
          <b-col cols="2"> Version: {{ $route.query.v }} </b-col>

          <b-col cols="9"> <slot name="footer"></slot> </b-col>
  
          <b-col cols="1" class="loading-pallete">
            <b-spinner small v-if="saving" />
          </b-col>
        </b-row>
      </Footer>
    </div>
  </div>
</template>

<style lang="scss">
body {
  background-color: #292d3e;
  overflow: hidden;
  position: static;
}

.CodeMirror,
.codeEditor,
.editorTabs,
.editorTab,
.editorPanel,
.editorPanelRight {
  height: 100% !important;
}
.tab-content {
  height: calc(100% - 3em);
}

.editor,
.editorTabs,
.tab-content,
.editorTab,
.sidebarPanel {
  width: 100%;
}

.app-footer {
  height: 30px !important;
  bottom: 0;
  background-color: #007acc;
  border: none;
  color: #fff;
  padding: 5px;
  font-size: 10px;
  width: 100%;
}

.editor {
  display: flex;
  height: calc(100vh - 4.5em)
}

.app-header {
  height: 20px;
}
.nav::-webkit-scrollbar {
	height: 2px;
  margin: 1em;
	background-color:0;
}
.nav::-webkit-scrollbar-thumb {
	border-radius: 10px;
	background-color: #bcd;
}
.nav::-webkit-scrollbar-track {
	border-radius: 10px;
	background-color: 0;
}
.nav-link {
  width: max-content;
}
.nav{
    overflow-x: auto;
    flex-wrap: nowrap;
    overflow-y: hidden;
}
.CodeMirror-hint {
  color: #fff;
}

.CodeMirror-hints {
  background-color: #292d3e;
}

.CodeMirror-cursor {
  border-left: 2px solid;
  border-right: 2px solid;
}

.dropdown-menu {
  padding: 4px 4px;
  font-size: 90%;
  background-color: #292d3e;
}

.dropdown-item {
  color: #fff;
  padding: .4rem 0.3rem;
}

.dropdown-item:hover {
  background-color: #1e88e5;
}

.vtl {
  color: #fff;
}

.treeview {
  background-color: #202330;
  font-size: 12px;
  width: 100%;
}

.vtl-node {
  white-space: pre;
}

.vtl-node-main .vtl-operation {
  margin: 0%;
}

.vtl-node-main:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.icon {
  &:hover {
    cursor: pointer;
  }
}

.muted {
  color: gray;
  font-size: 80%;
}

.fileIcon {
  width: 12px;
  height: 12px;
  margin-right: 10px;
}

.nav-tabs {
  border-radius: none;

  .nav-link {
    background: #232633;

    &.active {
      background: #292d3f;
      color: #fff;
      border: #292d3f;

      &:focus {
        background: #292d3f;
        color: #fff;
        border: #292d3f;
      }
    }
  }
}
.CodeMirror-overlayscroll-horizontal {
  bottom: 5px;
}
.tab-content {
  border-color: #292d3e;

  overflow: hidden;

  .tab-pane {
    background: #292d3f;
    border-color: #292d3e;
    width: 100%;
    height: 100% !important;
  }
}

.sidebarPanel {
  overflow: hidden;
  display: inline-block;
}

.editorTab {
  position: relative;
  overflow: hidden;

  &>* {
    width: 100%;
    overflow: hidden;
  }
}

.editorPanel {
  background: #202330;
  -webkit-box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);
  box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);

  z-index: 98;
}

.editorPanelRight {
  background: #202330;
  -webkit-box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);
  box-shadow: -7px 0px 5px 0px rgba(0, 0, 0, 0.2);
  z-index: 98;
  width: 100%;
}

.filePath {
  color: #73818f;
}

.closeTabIcon {
  &:hover {
    background: #202330;
  }

  position: relative;
  margin-left: 10px;
  left: 10px;
  padding: 5px;
  cursor: pointer;
}

.loading-pallete {
  text-align: right;
}

#right-click-menu {
  background: #202330;
  border: 1px solid #5f5f5f;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 5px;
  position: absolute;
  z-index: 999;
  border-radius: 5px;
  font-size: 12px;
}

#right-click-menu li {
  margin: 0;
  padding: 5px;
  color: #fff;
  cursor: pointer;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

.cm-matchhighlight {
  background-color: rgba(255, 255, 255, .1)
}

#right-click-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
  border-radius: 5px;
}

.handle {
  display: none !important;
}

.handle-mr {
  position: fixed;
  display: block !important;
  height: 100%;
  top: 0;
  width: 15px;
  opacity: 0;
  z-index: 999;
}

.vdr {
  height: 100% !important;
  border: none;
  overflow: scroll;
}
</style>

<script>
import { Header, Sidebar, SidebarNav, Footer } from "@/components/ui/vue/src";
import _ from "lodash";
import * as vueCodemirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/addon/display/autorefresh.js";
import "codemirror/addon/search/search.js";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/jump-to-line.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/display/placeholder.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/vue/vue.js";
import "codemirror/mode/css/css.js";
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/hint/javascript-hint.js";
import "codemirror/addon/hint/anyword-hint.js";
import "codemirror/addon/lint/json-lint.js";
import "codemirror/addon/lint/javascript-lint.js";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/lint/lint.js";
import "codemirror/addon/lint/lint.css";
import "codemirror/addon/selection/mark-selection.js";
import "codemirror/addon/selection/active-line.js";
import "codemirror/theme/material-palenight.css";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/comment/comment.js";
import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/search/match-highlighter.js";
import "codemirror/addon/scroll/simplescrollbars.css"
import "codemirror/addon/scroll/simplescrollbars"

import "./customAutoComplete.js";
import { additionalContext } from "./autocompleteList.js";

import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
import VueResizable from "vue-resizable";
import Vue from "vue";

// icons
import vueicon from "@/assets/editor/vuelogo.png";
import jsicon from "@/assets/editor/jsicon.png";
import cssicon from "@/assets/editor/cssicon.png";
import svgicon from "@/assets/editor/svgicon.png";
import jsonIcon from "@/assets/editor/jsonicon.png";

export default {
  name: "TemplateEditor",
  props: {
    value: {
      type: Array,
    },

    saving: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    codemirror: vueCodemirror.codemirror,
    Header,
    Footer,
    Sidebar,
    SidebarNav,
    VueTreeList,
    Tree,
    TreeNode,
    VueResizable,
  },
  data: function () {
    return {
      handlers: ["r"],
      templateReady: false,
      expressionError: "",
      activeEditors: [],
      activeEditorsRight: [],
      rightEditorWidth: 0,
      leftEditorWidth: "auto",
      pages: [],
      newTree: {},
      data: null,
      viewMenu: false,
      top: "0px",
      left: "0px",
      currentMenuNode: null,
      nodeEditable: null,
      sidebarWidth: 250,
      modules: {},
      appName: '',
      activeTab: null,
      activeTabRight: null,
      editorState: {
        activeEditors: [],
      },
    };
  },
  watch: {
    activeTabRight() {
      this.$nextTick(() => {
        const activeEditorRight = this.activeEditorsRight[this.activeTabRight];
        this.$refs.editorPanelRight.querySelectorAll('.CodeMirror')[this.activeEditorsRight.indexOf(activeEditorRight)].CodeMirror.focus();
      });
    },
    activeTab() {
      this.$nextTick(() => {
        const activeEditor = this.activeEditors[this.activeTab];
        this.$refs.editorPanel.querySelectorAll('.CodeMirror')[this.activeEditors.indexOf(activeEditor)].CodeMirror.focus();
      });
    },
  },
  computed: {
    nodes: {
      get() {
        return new Tree(this.value)
      },

      set(val) {
        this.$emit('input', val.children)
      }
    }

  },
  methods: {
    async onDel(node) {
      let resp = await this.$bvModal.msgBoxConfirm(
        "Are you sure you want to delete " + node.name + "?",
        {
          headerBgVariant: "dark",
          bodyBgVariant: "dark",
          footerBgVariant: "dark",
        }
      );
      if (!resp) return;

      node.remove();

      this.$emit('input', this.nodes.children)
    },

    onChangeName(node) {
      if (node.node) {
        // set ext of the file
        node.node.ext = this.resolveFileExt(node.newName);
        if (node.node.editorOptions)
          node.node.editorOptions.mode = this.resolveEditorMode(node.node.ext);
        // find active editor and change mode of editor depending on ext
        let activeEditor = this.findNodeByID(node.id, this.activeEditors);
        if (activeEditor) {
          activeEditor = node.node;
        }
      }

      this.$emit('input', this.nodes.children)
    },
    shouldShowHint(event) {
      const charCode = event.key.charCodeAt(0);
      return event.key.length === 1 &&
        (charCode >= 65 && charCode <= 90 ||
          charCode >= 97 && charCode <= 122 ||
          charCode === 95 || charCode === 36) &&
        !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey;
    },
    onCmReady(cm) {
      cm.options.hintOptions = { additionalContext };

      cm.on("keyup", (cm, event) => {
        if (!cm.state.completionActive && this.shouldShowHint(event)) {
          cm.showHint({ completeSingle: false });
        }
      });
    },

    resolveFileExt(name) {
      let parts = name.split(".");
      return parts[parts.length - 1];
    },

    resolveEditorMode(ext) {
      switch (ext) {
        case "vue":
          return "text/x-vue";
        case "js":
          return { name: "javascript", globalVars: true };
        case "css":
          return "text/x-less";
        case "svg":
          return "application/xml";
        case "json":
          return "application/json";
        default:
          return "text/plain";
      }
    },

    onClick(params) {
      if (!params.isLeaf) return;

      params.editorOptions = {
        mode: this.resolveEditorMode(this.resolveFileExt(params.name)),
      };

      let found = this.activeEditors.findIndex((e) => {
        return e.id == params.id;
      });

      if (found < 0) {
        this.activeEditors.push(params);
      } else {
        this.activeTab = found;
      }

      console.log("activeEditors", this.activeEditors)

      this.saveEditorState();
    },

    saveEditorState() {
      this.editorState.activeEditors = this.activeEditors.map((e) => {
        return e.path;
      });

      localStorage.setItem(
        `app_editor_${this.$route.params.id}`,
        JSON.stringify(this.editorState)
      );
    },

    loadEditorState() {
      let state = JSON.parse(
        localStorage.getItem(`app_editor_${this.$route.params.id}`)
      );

      if (state) {
        state.activeEditors.forEach((a) => {
          let node = this.findNodeByID(a.id);
          if (node) {
            this.onClick(node);
            return;
          }

          // remove node from state
          state.activeEditors = state.activeEditors.filter((e) => {
            return e != a;
          });
        });

        localStorage.setItem(
          `app_editor_${this.$route.params.id}`,
          JSON.stringify(state)
        );
      }
    },

    addNode(node) {
      if (!node.isLeaf) return;

      node.editorOptions = {
        mode: this.resolveEditorMode(this.resolveFileExt(node.name)),
      };
    },

    generateNodePath(n, p) {
      let path = p

      if (n && n.parent) {
        path = n.parent.name + "/" + path

        return this.generateNodePath(n.parent, path)
      }
      
      if (n.name == "root") {
        const appRoot = n.children[0].name

        return _.trimStart(path.replaceAll(`root/${appRoot}`, ""), "/")
      }

      return _.trimStart(path, "/")
    },

    editorOptions(override) {
      return {
        tabSize: 2,
        line: true,
        autoRefresh: true,
        lineNumbers: true,
        foldGutter: true,
        firstLineNumber: 1,
        styleSelectedText: true,
        matchBrackets: true,
        spellcheck: true,
        highlightSelectionMatches: { showToken: /\w/ },
        autoCloseBrackets: true,
        extraKeys: {
          "Ctrl-Space": "autocomplete",
          "Ctrl-/": "toggleComment",
        },
        showCursorWhenSelecting: true,
        theme: "material-palenight",
        scrollbarStyle: "overlay",
        ...override,
      };
    },

    editorInput: _.debounce(function (activeEditor, val) {
      let node = this.findNodeByID(activeEditor.id);
      node.content = val;

      this.$emit("input", this.nodes.children)
    }, 500),

    currentEditorValue(activeEditor) {
      return activeEditor.content || "";
    },

    findNodeByID(id, nodes) {
      if (!nodes) {
        nodes = this.nodes.children;
      }

      let node = null;
      for (let i = 0; i <= nodes.length; i++) {
        if (!nodes[i]) continue;

        if (nodes[i].id == id) {
          node = nodes[i];
          break;
        }

        if (!node) node = this.findNodeByID(id, nodes[i].children || []);
      }

      return node;
    },

    findNodeByPath(path, nodes) {
      if (!nodes) {
        nodes = this.nodes.children;
      }

      let node = null;
      for (let i = 0; i <= nodes.length; i++) {
        if (!nodes[i]) continue;

        const generatedPath = this.generateNodePath(nodes[i], nodes[i].name)
        if (generatedPath == path) {
          node = nodes[i];
          break;
        }

        if (!node) node = this.findNodeByPath(path, nodes[i].children || []);
      }

      return node;
    },

    closeActiveEditor(editor) {
      if (this.activeEditors.length < 2) return;

      this.activeEditors = this.activeEditors.filter((e) => {
        return e.id != editor.id;
      });
    },

    closeActiveEditorRight(editor) {
      this.activeEditorsRight = this.activeEditorsRight.filter((e) => {
        return e.id != editor.id;
      });
    },

    setMenu(top, left) {
      let largestHeight =
        window.innerHeight - this.$refs.right.offsetHeight - 25;
      let largestWidth = window.innerWidth - this.$refs.right.offsetWidth - 25;

      if (top > largestHeight) top = largestHeight;

      if (left > largestWidth) left = largestWidth;

      this.top = top + "px";
      this.left = left + "px";
    },

    closeMenu() {
      this.viewMenu = false;
    },

    openMenu(e, node) {
      e.preventDefault();

      this.currentMenuNode = node;

      if (this.nodeActions().length < 1) {
        return;
      }

      this.viewMenu = true;

      Vue.nextTick(
        function () {
          this.$refs.right.focus();

          this.setMenu(e.y - 30, e.x);
        }.bind(this)
      );
    },

    triggerNodeAction(action) {
      switch (action) {
        case "Delete":
          this.removeNode(this.currentMenuNode);
          break;
        case "Add file":
          this.addFile(this.currentMenuNode);
          break;
        case "Add folder":
          this.addFolder(this.currentMenuNode);
          break;
        case "Rename":
          this.renameNode(this.currentMenuNode);
          break;
        case "Open in Split View":
          this.OpenInSplitView(this.currentMenuNode);
          break;
      }

      this.closeMenu();
    },

    renameNode(node) {
      if (node.editNodeDisabled) {
        return;
      }

      this.nodeEditable = node.id;
      Vue.nextTick(
        function () {
          this.$refs.renameInput.focus();
        }.bind(this)
      );
    },

    OpenInSplitView(node) {
      node.editorOptions = {
        mode: this.resolveEditorMode(this.resolveFileExt(node.name)),
      };

      let found = this.activeEditorsRight.findIndex((e) => {
        return e.id == node.id;
      });

      if (found < 0) {
        this.activeEditorsRight.push(node);
      } else {
        this.activeTabRight = found;
      }
    },

    removeNode(node) {
      if (node.delNodeDisabled) {
        return;
      }

      this.$bvModal
        .msgBoxConfirm("Are you sure?", {
          headerBgVariant: "dark",
          footerBgVariant: "dark",
          bodyBgVariant: "dark",
        })
        .then((resp) => {
          if (resp) node.remove();
        });
    },

    addFile(node) {
      node.addChildren(
        new TreeNode({
          name: "new file",
          isLeaf: true,
          dragDisabled: false,
          addTreeNodeDisabled: true,
          addLeafNodeDisabled: true,
          delNodeDisabled: false,
          editNodeDisabled: false,
          children: null,
          editorOptions: {
            mode: "text/plain",
          },
        })
      );

      this.$emit('input', this.nodes.children)
    },

    addFolder(node) {
      node.addChildren(
        new TreeNode({
          name: "new folder",
          isLeaf: false,
          dragDisabled: false,
          addTreeNodeDisabled: false,
          addLeafNodeDisabled: false,
          delNodeDisabled: false,
          editNodeDisabled: false,
          children: [],
        })
      );

      this.$emit('input', this.nodes.children)
    },

    nodeActions() {
      let actions = [];
      let node = this.currentMenuNode;
      if (!node.isLeaf) {
        if (!node.addLeafNodeDisabled) {
          actions.push("Add file");
        }

        if (!node.addTreeNodeDisabled) {
          actions.push("Add folder");
        }
      }

      if (!node.delNodeDisabled) {
        actions.push("Delete");
      }

      if (!node.editNodeDisabled) {
        actions.push("Rename");
      }
      if (node.isLeaf) {
        actions.push("Open in Split View");
      }

      return actions;
    },

    nodeNameChange() {
      this.currentMenuNode.changeName(this.currentMenuNode.name);
      this.nodeEditable = null;
      this.onChangeName({
        newName: this.currentMenuNode.name,
        node: this.currentMenuNode,
      });
    },

    onEditorResize(data) {
      this.leftEditorWidth = data.width;
      this.$refs.editorPanelRight.style.width =
        window.innerWidth - this.sidebarWidth - data.width + "px";
    },

    onSidebarResize(data) {
      this.sidebarWidth = data.width;
    },

    iconRender(ext) {
      let icons = {
        vue: vueicon,
        js: jsicon,
        css: cssicon,
        svg: svgicon,
        json: jsonIcon,
      };

      return _.get(icons, ext, "");
    },
  },

  mounted() {
    document.onkeyup = function (e) {
      this.$emit('keyup', e)
    }.bind(this);

    this.loadEditorState();
  },
};
</script>
